export const codeGroupActionButton = (
  group,
  clickHandler,
  downloadPermission,
  ptrCodeGroupUpload,
  showLabels = false,
  hasMultiFileDownloadEnabled = false
) => {
  const compositeStatus = group?.compositeStatus?.toLowerCase();
  const labelMap = {
    view: "View",
    copy: "Copy",
    edit: "Edit",
    export: "Download",
    delete: "Delete",
  };
  const editableStatuses = ["draft", "active", "inactive"];
  const deletableStatuses = ["draft"];
  const exportableStatuses = ["active", "inactive", "generated", "expired"];

  const createAction = (action, icon) => ({
    action,
    icon,
    label: showLabels ? labelMap[action] : undefined,
    onClick: () => clickHandler(action, group),
  });

  const actionButtons = [createAction("view", "visibility")];

  if (editableStatuses.includes(compositeStatus)) {
    actionButtons.push(createAction("edit", "edit"));
  }

  if (
    exportableStatuses.includes(compositeStatus) &&
    downloadPermission &&
    !hasMultiFileDownloadEnabled &&
    !ptrCodeGroupUpload
  ) {
    actionButtons.push(createAction("export", "download"));
  }

  if (
    exportableStatuses.includes(compositeStatus) &&
    downloadPermission &&
    hasMultiFileDownloadEnabled &&
    !ptrCodeGroupUpload
  ) {
    actionButtons.push(createAction("downloadMultipleFile", "download"));
  }

  actionButtons.push(createAction("copy", "content_copy"));

  if (deletableStatuses.includes(compositeStatus)) {
    actionButtons.push(createAction("delete", "delete"));
  }

  return actionButtons;
};
